import api from '../httpClient';
import type { BugReport, BugReportMetadata, BugReportNote, PaginatedResponse } from '../../types';

export const bugReports = {
  list: (params: {
    status?: string[];
    severity?: string[];
    search?: string;
    page?: number;
    page_size?: number;
    exclude?: number;
  }) => {
    const { status, severity, ...rest } = params || {};
    const normalizedParams: Record<string, string | number> = {};
    Object.entries(rest || {}).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        return;
      }
      normalizedParams[key] = value as number | string;
    });
    if (status && status.length > 0) {
      normalizedParams.status = status.join(',');
    }
    if (severity && severity.length > 0) {
      normalizedParams.severity = severity.join(',');
    }
    return api
      .get<PaginatedResponse<BugReport>>('/api/bug-reports/', {
        params: normalizedParams,
      })
      .then((response) => response.data);
  },
  metadata: () =>
    api
      .get<BugReportMetadata>('/api/bug-reports/metadata/')
      .then((response) => response.data),
  create: (payload: {
    feedback_text: string;
    status?: string;
    severity?: string | null;
    duplicate_of_id?: number | null;
    closed_reason?: string | null;
    metadata?: Record<string, unknown>;
  }) => api.post<BugReport>('/api/bug-reports/', payload).then((response) => response.data),
  retrieve: (id: number) =>
    api.get<BugReport>(`/api/bug-reports/${id}/`).then((response) => response.data),
  update: (
    id: number,
    payload: Partial<
      Pick<BugReport, 'status' | 'closed_reason' | 'severity' | 'feedback_text'>
    > & {
      duplicate_of_id?: number | null;
    },
  ) =>
    api.patch<BugReport>(`/api/bug-reports/${id}/`, payload).then((response) => response.data),
  listNotes: (bugReportId: number, pageSize = 20) =>
    api
      .get<PaginatedResponse<BugReportNote>>('/api/bug-report-notes/', {
        params: {
          bug_report: bugReportId,
          page_size: pageSize,
        },
      })
      .then((response) => response.data),
  createNote: (bugReportId: number, note: string) =>
    api
      .post<BugReportNote>('/api/bug-report-notes/', {
        bug_report_id: bugReportId,
        note,
      })
      .then((response) => response.data),
  updateNote: (noteId: number, note: string) =>
    api
      .patch<BugReportNote>(`/api/bug-report-notes/${noteId}/`, {
        note,
      })
      .then((response) => response.data),
};
